export enum DtoneErrorsEnum {
    code1000400 = 1000400,
    code1000401 = 1000401,
    code1000404 = 1000404,
    code1003001 = 1003001,
    code1003002 = 1003002,
    code1003003 = 1003003,
    code1003101 = 1003101,
    code1003201 = 1003201,
    code1005003 = 1005003,
    code1005004 = 1005004,
    code1005005 = 1005005,
    code1005006 = 1005006,
    code1005503 = 1005503,
    code1006001 = 1006001,
    code1006003 = 1006003,
    code1006009 = 1006009,
    code1006503 = 1006503,
    code1007001 = 1007001,
    code1007002 = 1007002,
    code1007004 = 1007004,
    code1007005 = 1007005,
    code1007007 = 1007007,
    code1008004 = 1008004,
    code1009001 = 1009001
}

const significadoErrorDtone = new Map<DtoneErrorsEnum, string>();
significadoErrorDtone.set(DtoneErrorsEnum.code1000400, "Bad Request");
significadoErrorDtone.set(DtoneErrorsEnum.code1000401, "Falta autorización para conectar a la API de Dtone");
significadoErrorDtone.set(DtoneErrorsEnum.code1000404, "Endpoint de Dtone no encontrado");
significadoErrorDtone.set(DtoneErrorsEnum.code1003001, "Producto no disponible para el pais seleccionado");
significadoErrorDtone.set(DtoneErrorsEnum.code1003002, "Valor del producto pedido esta fuera del limite");
significadoErrorDtone.set(DtoneErrorsEnum.code1003003, "Unidad monetaria invalida");
significadoErrorDtone.set(DtoneErrorsEnum.code1003101, "Beneficios no definidos para los productos disponibles");
significadoErrorDtone.set(DtoneErrorsEnum.code1003201, "Promocion no encontrada");
significadoErrorDtone.set(DtoneErrorsEnum.code1005003, "El numero de telefono a recargar es invalido");
significadoErrorDtone.set(DtoneErrorsEnum.code1005004, "No se encontró el servicio");
significadoErrorDtone.set(DtoneErrorsEnum.code1005005, "No se encontró el pais");
significadoErrorDtone.set(DtoneErrorsEnum.code1005006, "No se encontró el operador (carrier)");
significadoErrorDtone.set(DtoneErrorsEnum.code1005503, "Numero invalido de quien envía el producto (sender)");
significadoErrorDtone.set(DtoneErrorsEnum.code1006001, "Balance (saldo) insuficiente");
significadoErrorDtone.set(DtoneErrorsEnum.code1006003, "Numero de telefono invalido");
significadoErrorDtone.set(DtoneErrorsEnum.code1006009, "No se encontró el balance de la cuenta");
significadoErrorDtone.set(DtoneErrorsEnum.code1006503, "Numero de telefono del beneficiario es invalido");
significadoErrorDtone.set(DtoneErrorsEnum.code1007001, "La external_id provista para la transacción ya fue utilizada");
significadoErrorDtone.set(DtoneErrorsEnum.code1007002, "La transacción ya habia sido confirmada");
significadoErrorDtone.set(DtoneErrorsEnum.code1007004, "La transaccion ya no se puede confirmar");
significadoErrorDtone.set(DtoneErrorsEnum.code1007005, "La transaccion ya había sido cancelada");
significadoErrorDtone.set(DtoneErrorsEnum.code1007007, "La transacción ya no se puede cancelar");
significadoErrorDtone.set(DtoneErrorsEnum.code1008004, "Transacción no encontrada");
significadoErrorDtone.set(DtoneErrorsEnum.code1009001, "Error inesperado, por favor contactese con el equipo de soporte de Dtone");

export const obtenerSignificadoErrorDtone: (error: DtoneErrorsEnum) => string =
        error => significadoErrorDtone.get(error) ?? "";
